<template>
    <div>
        <select-as-radio-field
            v-model="on_demand_treatment"
            :field="patientFields.on_demand_treatment"
            :errors="errors"
            :inline="false"
            field-name="on_demand_treatment"
            class="mb-3"
        />

        <input-field
            v-model="on_demand_treatment_prophylaxis"
            :field="patientFields.on_demand_treatment_prophylaxis"
            :errors="errors"
            :inline="false"
            :placeholder="$t('textarea.placeholder')"
            field-name="on_demand_treatment_prophylaxis"
            form-width="auto"
            class="mb-3"
            no-center-text
        />

        <array-field
            v-model="mutations"
            ref="mutationArray"
            :field="patientFields.mutations"
            :errors="errors"
            :placeholder="$t('textarea.placeholder')"
            field-name="mutations"
            class="mb-3"
        />

    </div>
</template>

<script>
    import InputField from "@/components/fields/InputField";
    import {mapState} from "vuex";
    import {mapStateProperty} from "@/utils/VuexHelpers";
    import {requiredIf} from "vuelidate/lib/validators";
    import ArrayField from "@/components/fields/ArrayField";
    import SelectAsRadioField from "@/components/fields/SelectAsRadioField";

    export default {
        name: "PatientTreatment",
        components: {SelectAsRadioField, ArrayField, InputField},
        computed: {
            ...mapState([
                'patientFields',
            ]),
            ...mapStateProperty([
                'patient.on_demand_treatment',
                'patient.on_demand_treatment_prophylaxis',
                'patient.mutations',
            ]),
            errors() {
                let errors = {};
                if (this.$v.on_demand_treatment_prophylaxis.$error) {
                    errors['on_demand_treatment_prophylaxis']  = [this.$t('error.required')];
                }
                return errors;
            }
        },
        methods: {
            validate() {
                this.$v.$touch();
                return !this.$v.$invalid;
            },
            back() {
                return true;
            },
        },
        validations: {
            on_demand_treatment_prophylaxis: {
                required: requiredIf(function () {
                    return this.on_demand_treatment === 'prophylaxis';
                })
            },
            mutations: {
                arrayMustBeValid: function () {
                    return !this.$refs.mutationArray.$v.value.$invalid;
                }
            }
        }
    };
</script>

<style scoped>

</style>